const { cELM } = require("../../utils");
const Chat = require("../../chat");

class SingleSelectObject {
  constructor(data) {
    this._data = data;
    this.options = this._data && this._data.values ? this._data.values : [];
    this.element = cELM("div", "option-block");
  }

  getELM() {
    return this.element;
  }

  getHTML() {
    const _self = this;
    this.options.forEach(option => {
      const optionName = option.name;
      const className = (optionName || '').indexOf('<div class="rate-') > -1 ? ' rate-opt' : '';
      const _el = cELM("div", 'option' + className);

      _el.onclick = function(evt) {
        _el.classList.toggle("option-active");

        let data = (window.__FN_DATA_WRAPPER) ? window.__FN_DATA_WRAPPER(option) : option;

        data = (typeof data == 'string') ? { text: data }: { ...data };

        Chat.default.send(data, null, _self.element);
      };

      _el.innerHTML = '<div class="option-text">' + optionName + "</div>";

      this.element.addELM(_el);
    });

    return this.element;
  }

  reset() {
    let sibling = this.element.firstChild;
    while (sibling) {
      sibling.classList.remove("option-active");
      sibling = sibling.nextSibling;
    }
    this.selectedOptions = [];
  }

  focus() {}
}

module.exports = SingleSelectObject;
